import { Component, Input, OnInit } from '@angular/core';
import { GameRecordListItemDisabled } from '../model/list';
import { deepCopy, determineLocale, statusColorsLabSampleGR } from 'diwimamodelweb/lib';
import { firstValueFrom, skipWhile, take } from 'rxjs';
import { SettingsService } from '../settings.service';
import { HuntingDistrictService } from '../hunting-district.service';

@Component({
  selector: 'app-gamerecord-list-item-disabled',
  templateUrl: './gamerecord-list-item-disabled.component.html',
  styleUrls: ['./gamerecord-list-item-disabled.component.css']
})
export class GamerecordListItemDisabledComponent implements OnInit {

  @Input() data: GameRecordListItemDisabled
  locale: string|undefined = undefined
  statusColorsLabSampleGR = statusColorsLabSampleGR

  hi_tier:any
  nvTrichinella:any

  backgroundColor:string = "#fbf8fb"
  allHDs = []

  constructor(private settingsService: SettingsService,
    private hdService: HuntingDistrictService) {
    this.locale = determineLocale(navigator.language)
  }

  async ngOnInit(): Promise<void> {
    this.allHDs = this.hdService.huntindDistrictSubject$.value

    const context:any = await firstValueFrom(this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
      take(1)
    ))
    this.hi_tier = context.modulesMap?.get('hi-tier') ? true : false
    this.nvTrichinella = context.modulesMap?.get('nvTrichinella') ? true : false
    
  this.getGRColor()
  }

  click() {
    // this.data.onClick()//---------comment for disabled
  }

  delete() {
    // this.data.onDelete()//------- comment for disabled
  }

  getLabColor(lab){
    return this.statusColorsLabSampleGR?.find( s => s.type === lab.state)?.color
  }

  getGRColor(){
    const samples = deepCopy(this.data.data?.laboratorySamples ?? undefined)
    const rep: { [key: string]: number } = {};
    const wildart = this.data?.data?.wildart ?? ""

    if(!samples) {
      if(this.hi_tier || this.nvTrichinella) {
        if(wildart === "Schwarzwild" || wildart === "Dachs"){
          const hd = this.allHDs?.find(hd => hd.identifier === this.data.data.huntingDistrictId)
          if(hd?.nvTrichinellaActive || hd?.hiTierActive)
            this.backgroundColor = "#f009"
          // else
          //   this.backgroundColor = "#fbf8fb"//white
        }
      }
      return;
    }

    // samples.forEach(sample => {
    //   if(sample.nvState && !sample.hiTierState)
    //   rep[sample.nvState] = (rep[sample.nvState] ?? 0) + 1
    //   if(sample.hiTierState && !sample.nvState)
    //   rep[sample.hiTierState] = (rep[sample.hiTierState] ?? 0) + 1
    //   if(sample.hiTierState && sample.nvState && sample.hiTierState == sample.nvState)
    //   rep[sample.hiTierState] = (rep[sample.hiTierState] ?? 0) + 1
    //   if(sample.hiTierState && sample.nvState && sample.hiTierState != sample.nvState) {
    //     rep[sample.hiTierState] = (rep[sample.hiTierState] ?? 0) + 1
    //   }
    // });

    // let max = 0
    // let nvState = undefined
    // let maxPrio = Infinity

    // Object.keys(rep).forEach( state=> {
    //   const count = rep[state]
    //   const priority = this.statusColorsLabSampleGR.find( s => s.type === state)?.sort ?? Infinity;
    //   if( count > max || (count === max && priority < maxPrio)){
    //     max = rep[state]
    //     nvState = state
    //     maxPrio = priority
    //   }
    // })
    // this.backgroundColor = this.statusColorsLabSampleGR.find( s => s.type === nvState)?.color

    const allstates = [...new Set( samples.flatMap(i => [i.nvState, i.hiTierState]) )];

    if (allstates?.includes('skippedSubmission' ) || allstates?.includes('submissionFailed') 
      || allstates?.includes('certificateFailed')
      || allstates?.includes('authenticationFailed') || allstates?.includes('sampleRejected')
    ) {
      this.backgroundColor = 'rgba(255, 0, 0, 0.6)'//red
      return;
    }
     
    if (allstates?.includes('pendingSubmission'  ) || allstates?.includes('pendingResults' ) || allstates?.includes('pendingResult' ) || allstates?.includes('certificatePending' )) {
      this.backgroundColor = 'rgba(255,255,0,0.3)' //yellow
    }

  }

}
